import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';









const Merit2024 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/1.webp`;
  const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/2.webp`;
  const p3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/3.webp`;
  const p4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/4.webp`;
  const p5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/5.webp`;
  const p6 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/6.webp`;
  const p7 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/7.webp`;
  const p8 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/8.webp`;
  const p9 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/9.webp`;
  const p10 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/10.webp`;
  const p11 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/11.webp`;
  const p12 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Achievements/2024/Scholership/12.webp`;
  

  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p5,
      source: p5,
      rows: 1,
      cols: 1,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
      },
      {
        src: p7,
        source: p7,
        rows: 1,
        cols: 1,
      },
      {
        src: p8,
        source: p8,
        rows: 1,
        cols: 1,
      },
      {
        src: p9,
        source: p9,
        rows: 1,
        cols: 1,
      },
      {
        src: p10,
        source: p10,
        rows: 1,
        cols: 1,
      },
      {
        src: p11,
        source: p11,
        rows: 1,
        cols: 1,
      },
      {
        src: p12,
        source: p12,
        rows: 1,
        cols: 1,
      },
  ];

  return (
    <Main>
 
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
       
          <Container
      
      >
        <Box>
          <Box >
            <Typography
              variant="h2"
              align={'center'}
           
            >
            Merit Scholarship 2024-25 
            </Typography>
            


                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                School has introduced Merit Scholarship for students of Class 11 for their exceptional performance in Class 10 CBSE Board Examination. This prestigious scholarship is a recognition of their hard work, dedication and outstanding performance in Academics and Co-Scholastic areas. The Certificate and Scholarship was awarded to the Academic Toppers of Class 10 who continued with the school for the Senior Secondary Classes 11 &12.
                                </Typography>
          </Box>
          <Box>
            <Typography
              variant="h4"
              align={'center'}
              sx={{
                fontWeight: 700,
                color: theme.palette.common.white,
              }}
            >
              
            </Typography>
          </Box>
        </Box>
      </Container>
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 350 : 250}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
        
      )}
    </Box>
        </Main>
  );
};

export default Merit2024;